/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelExternalChat = new Class({
    Extends:QuriobotElement,
    initialize: function(args, naturalDelayConfig, variables){
        args[0].options.forEach(function(option){
            option.type = this.getOptionTypeByURL(option.url)
            if (option.type === "empty") {
                option.url = "#"
            }
        }.bind(this))

        args[0].options.forEach(function(option){
            option.target = this.getOptionTargetByType(option.type)
        }.bind(this))

        this.parent(args, naturalDelayConfig, variables)
    },
    getOptionTypeByURL: function(url) {
        if(url) {
            if (url.indexOf("/m.me") != -1 || url.indexOf("messenger.com") != -1) return "messenger";
            else if (url.indexOf("whatsapp") != -1) return "whatsapp";
            else if (url.indexOf("skype:") != -1) return "skype";
            else if (url.indexOf("weixin:") != -1) return "wechat";
            else if (url.indexOf("tg:") != -1 || url.indexOf("telegram") != -1) return "telegram";
            else if (url.indexOf("viber:") != -1) return "viber";
            else if (url.indexOf("slack:") != -1) return "slack";
            else if (url.indexOf("snapchat") != -1) return "snapchat";
            else if (url.indexOf("line:") != -1) return "line";
            else if (url.indexOf("tel:") != -1) return "tel";
            else if (!url || url === "#") return "empty";
            else return "default";
        }
    },
    getOptionTargetByType: function(type) {
        switch (type) {
            case "empty":
                return "_self"
            default:
                return "_blank"
        }
    },
    template: function(){
        var base =  '<div class="panel--wrapper panel--button isLoading{% button-state %}" family="{{ key }}" id="{{ eid }}">'+
                    '    <div class="panel--main">'+
                    '        <div class="panel--content">'+
                    '            <div class="external-chat__list">'+
                    '                {% options %}'+
                    '            </div>'+
                    '            {% button %}'+
                    '        </div>'+
                    '        <div class="panel--overlay">'+
                    '            <div class="icon--checkWrapper fromBottom circle">'+
                    '                <div class="check"></div>'+
                    '            </div>'+
                    '            <button type="button" aria-label="' + this.data.i18n.redo.button.title + '" aria-hidden="true" class="icon--redoWrapper">'+
                    '                <div class="redo"></div>'+
                    '            </button>'+
                    '        </div>'+
                    '    </div>'+
                    '</div>';

        var option = '<div class="external--chat__item">'+
                     '   <a class="large--button button--social is-{{ type }}" href="{{ url }}" target="{{ target }}" data-button-id="{{ id }}">'+
                     '       <div class="socialIcon socialIcon-{{ type }}"></div>'+
                     '       <div class="button--text">{{{ text }}}</div>'+
                     '   </a>'+
                     '</div>';

         var button = '<div class="panel--done">'+
                      '   <button type="submit" class="done--button">'+
                      '        <div class="button--arrow"></div>'+
                      '   </button>'+
                      '</div>';

        return {'base': base, 'option': option, 'button': button};
    },
    attach: function(){
        var Wrapper = this.element.getElements('.panel--externalChat');
        var Buttons = this.element.getElements('.button--social');
        var Skip = this.element.getElements('.done--button');

        this.selected = {
            values: [],
            content: []
        };

        Buttons.each(function(button,i) {
            button.addEvents({
                click: function(e){
                    var Selected = this.element.getElements('a.button--social.selected--button');

                    if(!button.hasClass('selected--button')){
                        Selected.removeClass('selected--button');
                        button.addClass('selected--button');
                        this.selected.values = [];
                        this.selected.content = [];
                        this.selected.values.push(button.get('data-button-id'));
                        this.selected.content.push(button.getElements('.button--text')[0].get('text'));
                        this.after();
                    }

                    this.foldOutClose();
                    this.after();
                }.bind(this)
            });
        }.bind(this));

        if(Skip.length){
            Skip.each(function(skipBtn, i){
                skipBtn.addEvents({
                    click:function(){
                        this.selected.values = [];
                        this.after();
                    }.bind(this)
                });
            }.bind(this));
        }
    },
    after: function(){

        // Add `aria-hidden="true"` after answering to the question
        this.setAriaHidden('.external-chat__list', true);

        // Remove `aria-hidden="true"` from redo-button
        this.setAriaHidden('.icon--redoWrapper', false);

        var answerData = {
            answer:{
                'render': false,
                'value': this.selected.values,
                'content': this.selected.content
            }
        };
        this.element.addClass('isAnswered');
        this.answerCallback(this.data, answerData);
    }
});
